<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="70%">
      <v-form ref="formUser" v-model="valid" lazy-validation @submit.prevent="saveDataMoodle">
        <v-card>
          <v-card-title class="primary white--text">Restablecer Credenciales de Moodle</v-card-title>
          <v-card-text class="pa-4" v-if="persona">
            <v-text-field
              readonly
              outlined
              :rules="fieldRules"
              dense
              v-model="persona.email"
              label="Email"></v-text-field>
            <div>
              <v-text-field
                readonly
                outlined
                :rules="fieldRules"
                dense
                v-model="persona.usuario_moodle"
                label="Usuario por defecto de Moodle"
                prepend-icon="mdi-account-arrow-right"></v-text-field>

              <v-text-field
                outlined
                readonly
                :rules="fieldRules"
                dense
                label="Contraseña por defecto de Moodle"
                v-model="persona.clave_moodle"
                prepend-icon="mdi-form-textbox-password"></v-text-field>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn type="submit" color="amber" rounded>
              <v-icon class="mr-1"> mdi-content-save</v-icon> Restablecer
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
              Cancelar <v-icon> mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
export default {
  props: ['programa'],
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      //api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      dialog: false,
      valid: false,
      register: false,
      value: String,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      persona: null,
      //   ----new data-----
      username: null,
      password: null,

      datamsg: '',
      plataforma: {},
      msgerr: '',
    };
  },
  methods: {
    showThisView(id) {
      this.register = false;
      this.dialog = true;
      const sql = gql`query{ getPersona(id:${id}){ id num_doc nombres pri_apellido seg_apellido telefono1 usuario_moodle clave_moodle email sexo tipo diestro profesiones{id}} }`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        this.persona = data.getPersona;
        this.persona.profesiones = this.persona.profesiones.map(({ id }) => id);
        delete this.persona.__typename;
        // window.console.log(data.getPersona, window.stringifyObject(this.persona));
        this.username = this.persona.usuario_moodle;
        this.password = this.persona.clave_moodle;
      });
    },
    saveDataMoodle() {
      if (this.$refs.formUser.validate()) {
        this.$root.$confirm.open('Restablecer contraseña', 'Estas seguro?', { color: 'orange' }).then((confirm) => {
          if (confirm) {
            this.msgerr = '';
            if (!this.plataforma.id) {
              this.getDatosPlataformas();
            }
            const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
              this.plataforma.id
            }/user`;
            let data = {
              current_username: this.persona.usuario_moodle,
              username: this.username,
              password: this.password,
              firstname: this.persona.nombres,
              lastname: `${this.persona.pri_apellido} ${this.persona.seg_apellido ? this.persona.seg_apellido : ''}`,
              email: this.persona.email,
              phone1: this.persona.telefono1,
            };
            // window.console.log(url, data);
            xaxios
              .put(url, data)
              .then((response) => {
                if (response.status == 200) {
                  this.$root.$notify.show('Contraseña reseteada', { color: 'success' });
                  this.closeDialog();
                } else {
                  this.$root.$notify.show('No fue posible restablecer la contraseña', { color: 'red' });
                }
              })
              .catch(({ response }) => this.$root.$notify.show(response.data.error, { color: 'primary' }));
          }
        });
      }
    },

    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`
            query {
              getPlataformas {
                id
                nombre
                direccion
              }
            }
          `,
        })
        .then(({ data: { getPlataformas } }) => {
          if (!getPlataformas) getPlataformas = [];
          this.plataformas = getPlataformas;
          // window.console.log(this.plataformas, this.programa)
          let plataforma_id = this.programa.plataforma_id;
          this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
          if (!this.plataforma) {
            this.datamsg = `<b>Plataforma</b>: Sin plataforma asignada.`;
            return;
          }
          this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
        })
        .catch((err) => {
          window.console.error(err);
          // this.$root.$notify.show(`ERROR: getPlataformas(ResetPasswordMoodle) ${err}`)
        });
    },

    closeDialog() {
      this.dialog = false;
      this.persona = null;
      this.username = null;
      this.password = null;
    },
  },

  mounted() {
    this.getDatosPlataformas();
  },
};
</script>

<style>
</style>